// removed by extract-text-webpack-plugin
module.exports = {"item":"_2yZ6Y","label":"_3Tudl","collapseIcon":"_1HXdR","expandIcon":"_2-3Hb","active":"_3Tg7j","itemContent":"_1kK6d","hidden":"_1hlLU","visible":"_38_as"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Accordion/components/Tab/Tab.scss
// module id = 1348
// module chunks = 1